const NINAL_SHORTER_NAME = {
  NINAL: 'NINAL',
  'NINAL step': 'NINAL step',
  'NINAL step 延長': 'NINAL step',
  'NINAL PREMIUM': 'NINAL PREMIUM',
  'NINAL CUSTOM': 'NINAL CUSTOM',
  'NINAL社割/社員本人・役員': 'NINAL',
  'NINAL社割/家族知人・眼科耳鼻科': 'NINAL',
  'NINAL step社割/社員本人・役員': 'NINAL step',
  'NINAL step社割/家族知人・眼科耳鼻科': 'NINAL step',
  'NINAL step 延長社割/社員本人・役員': 'NINAL step',
  'NINAL step 延長社割/家族知人・眼科耳鼻科': 'NINAL step',
  'NINAL PREMIUM社割/社員本人・役員': 'NINAL PREMIUM',
  'NINAL PREMIUM社割/家族知人・眼科耳鼻科': 'NINAL PREMIUM',
  'NINAL CUSTOM/社員本人・役員': 'NINAL CUSTOM',
  'NINAL CUSTOM/家族知人・眼科耳鼻科': 'NINAL CUSTOM',
}

export default NINAL_SHORTER_NAME
